import { render, staticRenderFns } from "./teacherResource.vue?vue&type=template&id=e7ac96f2&scoped=true&"
import script from "./teacherResource.vue?vue&type=script&lang=js&"
export * from "./teacherResource.vue?vue&type=script&lang=js&"
import style0 from "./teacherResource.vue?vue&type=style&index=0&id=e7ac96f2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7ac96f2",
  null
  
)

export default component.exports